<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card
          title="جزئیات بنر"
        >
          <b-form
            ref="bannerform"
            @submit.prevent
          >
            <b-row>

              <b-col
                class="mt-2"
                md="6"
                offset-md="3"
              >
                <b-row>

                    <b-col
                            class="image"
                            cols="12"
                    >
                        <b-media class="mb-2">
                            <template #aside>
                                <b-avatar
                                        ref="previewEl"
                                        :src="Form.Image"
                                        size="90px"
                                        rounded
                                        button
                                        @click="$refs.refInputEl.click()"
                                />
                            </template>
                            <input
                                    :ref="'refInputEl'"
                                    type="file"
                                    class="d-none"
                                    name="Image"
                                    @input="imageRenderer($event)"
                            >
                            <b-row>
                                <b-col md="12">
                                    <b-form-group
                                            label="عنوان"
                                            label-for="Title"
                                            class="mb-0"
                                    >
                                        <b-form-input
                                                id="Title"
                                                v-model="Form.Title"
                                                name="Title"
                                                autocomplete="off"
                                        />
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </b-media>
                    </b-col>


                  <b-col md="6">
                    <b-form-group
                      label="جایگاه"
                      label-for="BannerPositionId"
                    >
                      <z-banner-position v-model="Form.BannerPositionId" />
                    </b-form-group>
                  </b-col>



                  <b-col md="6">
                    <b-form-group
                      label="وضعیت"
                      label-for="IsActive"
                    >
                      <v-select
                        v-model="Form.IsActive"
                        :options="enums('IsActive')"
                        dir="rtl"
                        label="text"
                        :clearable="false"
                        :reduce="x => x.value"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="8">
                    <b-form-group
                        label="لینک"
                        label-for="Url"
                    >
                      <b-form-input
                          id="Uri"
                          v-model="Form.Url"
                          autocomplete="off"
                          name="Url"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="ترتیب"
                        label-for="Sort"
                    >
                      <b-form-input
                          id="Sort"
                          v-model="Form.Sort"
                          autocomplete="off"
                          type="number"
                          name="Sort"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import ZBannerPosition from '@/tools/bannerposition.vue'
import selectSegmentCustom from '@/tools/selectSegmentCustom.vue'

export default {
  name: 'BannerDetails',
  components: {
    ZBannerPosition,
    selectSegmentCustom,
  },
  data() {
    return {
      Form: {
        Id: null,
        Title: null,
        Url: null,
        Sort: 0,
        BannerPositionId: null,
        IsActive: true,
      },
      loading: false,
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }
  },
  methods: {
    save() {
      let url = this.$api.banner.add
      if (this.$route.params.id) {
        url = this.$api.banner.update
      }

      const formData = new FormData(this.$refs.bannerform)

      if (this.Form.BannerPositionId) {
        formData.append('BannerPositionId', this.Form.BannerPositionId)
      }

      formData.append('IsActive', this.Form.IsActive)
      formData.append('Id', this.Form.Id)

      this.loading = true
      this.$http.post(
        url, formData,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
      imageRenderer(event) {
          const fileReader = new FileReader()
          fileReader.readAsDataURL(event.target.files[0])

          fileReader.onload = () => {
              this.Form.Image = fileReader.result
          }
      },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.banner.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
  },
}
</script>

<style scoped>
.image .media-body {
  align-self: flex-end;
}
</style>
